import { gql } from "@apollo/client";

export const GET_LOCALIDADES = gql`
query QLocalidades ($idProvincia: Int!) {
    localidades (idProvincia: $idProvincia)
    {
        success,
        error,
        valorEsperado {
            idLocalidad,
            idProvincia,
            descripcion,
            codigoPostal
        }
    }
}`;